import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getScheduleLiveAccount = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule/account-livestream/list?${queries}` });

  return data?.data;
};

export default getScheduleLiveAccount;
